export const aboutFile = [
  {
    date1: "April 2022",
    title1: "DeskTime introduces the new Booking feature",
    description1:
      "Users can now book desks, meeting rooms, parking spaces, and much more. All bookings are updated in real-time and can be viewed from a single booking grid. It's the best way to manage shared and hybrid workspaces, and another step closer to DeskTime becoming an all-in-one office management system.",
    img1: "https://desktime.com/assets/img/about/booking@3x.png",
    date2: "January 2022",
    title2: "DeskTime provides web-based time tracking",
    description2:
      "The new manual web timer lets users enjoy DeskTime from any browser without downloading and installing any software. You can use it as an alternative to automated time tracking or together with the DeskTime app.",
    img2: "https://desktime.com/assets/img/about/web-timer@3x.png",
  },
  {
    date1: "December 2021",
    title1: "Per-user pricing model introduced",
    description1:
      "We gave up all pricing plans that were based on specific user count amplitudes and instead opted for per-user pricing. This lets you make easy calculations about how much you'll pay based on the number of people using DeskTime.",
    img1: "https://desktime.com/assets/img/about/pricing@3x.png",
    date2: "September 2021",
    title2: "DeskTime is now fully available in Spanish",
    description2:
      "The full-system localization, which has been in the works for a while, is finalized. It's a step that makes our website and productivity tips more accessible to Spanish-speaking communities across the globe.",
    img2: "https://desktime.com/assets/img/about/spanish@3x.png",
  },
  {
    date1: "July 2021",
    title1:
      "Mac and Linux users get an upgrade in the Electron software framework",
    description1:
      "The new and improved functionality for Mac and Linux users in the Electron software framework has made using DeskTime faster and more convenient. The update introduced user interface improvements in the app and Project Manager, a passwordless magic link login, and a project Quick menu for added user experience.",
    img1: "https://desktime.com/assets/img/about/electron@3x.png",
    date2: "May 2021",
    title2: "Bootstrap 4 is implemented",
    description2:
      "We've always been about efficiency, and a good user experience is one of the cornerstones of that goal. That's why we implemented Bootstrap 4 in our system. It improved our website's accessibility ratings, making it perceivable, understandable, as well as easier to navigate and operate for all our users.",
    img2: "https://desktime.com/assets/img/about/bootstrap4@3x.png",
  },
  {
    date1: "March 2021",
    title1: "On-demand webinars are live",
    description1:
      "When it comes to software demonstration video tutorials work wonders. It's the easiest way to make sure our customers get the most out of all the features DeskTime has to offer. On-demand webinars do just that. We redesigned our webinar landing page and made the short and easy how-to videos available for anyone at any time.",
    img1: "https://desktime.com/assets/img/about/on-demand@3x.png",
    date2: "January 2021",
    title2: "¡Hola! ¿Necesita ayuda? Support is now available in Spanish",
    description2:
      "It's all about the best customer support these days, and we're up for the challenge. DeskTime achieves one of our biggest goals for 2021 – our support is now available in the Spanish language. Next up – a full system localization. ¡vamos!",
    img2: "https://desktime.com/assets/img/about/support@3x.png",
  },
  {
    date1: "December 2020",
    title1: "New Year, new us! Making first impressions count",
    description1:
      "To close out 2020 and kick-off 2021 fresh, DeskTime's homepage receives a dapper redesign that better captures who we are, what we do, and what we stand for. And it's also prettier. Much prettier. Which is just as important!",
    img1: "https://desktime.com/assets/img/about/homepage@3x.png",
    date2: "October 2020",
    title2: "Coming home: DeskTime is now an EU-based company",
    description2:
      "Even though, legally speaking, we've been a US-based company from the very beginning, our main center of operations has always been Latvia. Now, we're just changing our legal address and legal name to have everything in one place.",
    img2: "https://desktime.com/assets/img/about/eu-company.svg",
  },
  {
    date1: "July 2020",
    title1: "Faster, better, stronger",
    description1:
      "We upgraded our physical infrastructure by deploying new servers in the USA and India to meet the needs of our growing user base in these and nearby markets. DeskTime users from these areas now have an even smoother and faster DeskTime experience.",
    img1: "https://desktime.com/assets/img/about/server.svg",
    date2: "June 2020",
    title2: "Reaching every corner of the world - Reseller program launched!",
    description2:
      "DeskTime begins working with resellers and distributors worldwide to make payments easier and break down language and communication barriers for new users in countries beyond our main base of operations, thus ensuring broader and better accessibility to DeskTime.",
    img2: "https://desktime.com/assets/img/about/world.svg",
  },
  {
    date1: "April 2020",
    title1: "Update of the year – a brand new mobile app",
    description1:
      "The DeskTime mobile app gets a major update, both UX and feature-wise. The renewed app now includes a mobile timer for time tracking on the go, allows you to assign time to individual projects, and log offline time.",
    img1: "https://desktime.com/assets/img/about/mobile-app@3x.png",
    date2: "March 2020",
    title2: "Prime plans for prime customers",
    description2:
      "Two new pricing plans are introduced to fit the needs of our premium and enterprise-level customers. The new plans – Premium and Enterprise – offer clients a bunch of extra features and functionalities, as well as priority support.",
    img2: "https://desktime.com/assets/img/about/pricing-plans@3x.png",
  },
  {
    date1: "February 2020",
    title1: "Hello, Exports and Invoicing!",
    description1:
      "DeskTime adds two new features, becoming an even more powerful work tool for both teams and freelancers. With Exports, users can download detailed productivity data as .csv or .xls files, while Invoicing lets you create, send, and track your invoices.",
    img1: "https://desktime.com/assets/img/about/invoicing@3x.png",
    date2: "December 2019",
    title2: "81 million hours tracked – that's 9268 years",
    description2:
      "The total time tracked by all DeskTime users reaches 81 million hours – that’s 9268 years. In linear time, that's as if DeskTime had tracked every minute since homo sapien domesticated cats in around 8000 BC. DeskTime now works in 203 countries, serving 184 000 users in 8600 companies",
    img2: "https://desktime.com/assets/img/about/8000bc@3x.png",
  },
  {
    date1: "October 2019",
    title1: "The re-birth of DeskTime's YouTube channel",
    description1:
      "The DeskTime team sets a goal to create entertaining and practically useful content on YouTube to have an even more open conversation about productivity, management, and time tracking and the benefits behind it.",
    img1: "https://desktime.com/assets/img/about/youtube@3x.png",
    date2: "September 2019",
    title2: "Introducing Shift Scheduling",
    description2:
      "A new feature is introduced – employee shift scheduling. It allows managers to plan shifts, see a complete overview of created shifts, that way avoiding overstaffing and understaffing. It also gives an insight into shift workers' productivity.",
    img2: "https://desktime.com/assets/img/about/scheduling@3x.png",
  },
  {
    date1: "April 2019",
    title1: "Introducing annual billing",
    description1:
      "Users are offered a more convenient and cost-efficient billing option. With the annual payment, users are charged once a year and save a month's worth of fees.",
    img1: "https://desktime.com/assets/img/about/annual-billing@3x.png",
    date2: "March 2019",
    title2: "Project tracking gets an update",
    description2:
      "One of the most popular features – project tracking – becomes easier to administer. New user-friendly functionalities are added, including project search and time and cost estimation",
    img2: "https://desktime.com/assets/img/about/project-tracking@3x.png",
  },
  {
    date1: "January 2019",
    title1: "New integrations – Trello and Gitlab",
    description1:
      "DeskTime continues to add integrations with popular work tools. The Trello and Gitlab integrations allow users to automatically import their cards and issues to DeskTime and track time",
    img1: "https://desktime.com/assets/img/about/gitlab@3x.png",
    date2: "December 2018",
    title2: "We’ve tracked 63 million hours or 7228 years",
    description2:
      "DeskTime now works in 174 countries, serving 144 000 users in 6700 companies. Until this time, we’ve tracked 63 million hours - that’s 7228 years.",
    img2: "https://desktime.com/assets/img/about/pyramid@3x.png",
  },
  {
    date1: "July 2018",
    title1: "DeskTime introduces the Pomodoro Timer",
    description1:
      "The most requested feature of 2017/2018 is here! Users can now enable the built-in Pomodoro timer to remind themselves to take regular breaks - every 52, 60 or 90 minutes.",
    img1: "https://desktime.com/assets/img/about/pomodor@3x.png",
    date2: "June 2018",
    title2: "Integrations with major project management apps",
    description2:
      "DeskTime now integrates with Jira, Asana, Basecamp, and Zapier. Users can pull their projects into DeskTime and log their time within the apps. Additionally, My DeskTime gets a new Messaging feature. Users can now leave notes for their colleagues right inside DeskTime.",
    img2: "https://desktime.com/assets/img/about/integrations@3x.png",
  },
  {
    date1: "January 2018",
    title1: "DeskTime picks up speed",
    description1:
      "DeskTime changes its database servers and doubles their speed and capacity. The same month, the DeskTime desktop app gets new design icons on Windows, MAC, and Linux.",
    img1: "https://desktime.com/assets/img/about/speed@3x.png",
    date2: "September 2017",
    title2: "DeskTime launches its first integration - with Google Calendar",
    description2:
      "The DeskTime + Google Calendar integration automatically logs users' offline time - the time they've been away from their computer, in meetings or for other work-related reasons. That way, users now can see how much time they spend in meetings, business lunches, work-related trainings, and more",
    img2: "https://desktime.com/assets/img/about/calendar@3x.png",
  },
  {
    date1: "July 2017",
    title1: "The 100,000th user joins DeskTime",
    description1:
      "Today, over 100K people in 98 countries use DeskTime to optimize their work time and get more things done. Which, apparently, works: the stats show that DeskTime users have an average productivity of 80.9%. It means, out of an 8-hour workday, almost 6.5 hours are spent on work-related tasks.",
    img1: "https://desktime.com/assets/img/about/100000@3x.png",
    date2: "March 2017",
    title2: "Here come Screenshots - the most requested feature of all time",
    description2:
      "After insistent customer requests, DeskTime adds the Screenshots feature. The new feature lets managers capture employees’ screens in random 15-minutes intervals to follow the work in progress. It is mostly used to manage remote teams, where employees are paid by the hour.",
    img2: "https://desktime.com/assets/img/about/screenshot@3x.png",
  },
  {
    date1: "June 2016",
    title1: "DeskTime gets makeover with major functional updates",
    description1:
      "The app gets a design makeover. The new design makes it easier for users to read their data - graphics and other data visualizations are now made more comprehensive. Additionally, another set of much requested features is added, including the Absence calendar and Colleagues. The new features let teams better organize their time off and store colleagues’ contact information in one place.",
    img1: "https://desktime.com/assets/img/about/design@3x.png",
    date2: "July 2015",
    title2: "The team starts its work on DeskTime's new version",
    description2:
      "The long work on DeskTime's third version begins. By paying a great attention to detail, the new version aims to improve user experience and make the software's user interface more comprehensive.",
    img2: "https://desktime.com/assets/img/about/v3@3x.png",
  },
  {
    date1: "August 2014",
    title1: "A study conducted by DeskTime goes viral",
    description1:
      "DeskTime analyzes the top 10% of its most productive employees and discovers their one common trait: they work 52 minutes, then break for 17 minutes. Originally published on Daily Muse, the article goes viral and gets republished by Mashable, Business Insider, Inc.com and Lifehacker, and many other popular media.",
    img1: "https://desktime.com/assets/img/about/viral@3x.png",
    date2: "October 2013",
    title2: "DeskTime becomes profitable",
    description2:
      "At the end of 2013 DeskTime stands on its own feet and starts working with profit. The startup can now cover its own expenses and doesn't needs no help from other companies within the Draugiem Group.",
    img2: "https://desktime.com/assets/img/about/profit@3x.png",
  },
  {
    date1: "October 2012",
    title1:
      "DeskTime gets its first major update - fresh design and new features",
    description1:
      "Adding various major features, DeskTime launches its second version. From now on, users can track their projects and tasks with the Projects feature, create and download Reports, and track their Offline time – read: log the time they’ve spent away from the computer. The new version also has a fresh, user-friendly design and better visualization of the tracked data.",
    img1: "https://desktime.com/assets/img/about/v2@3x.png",
    date2: "February 2012",
    title2: "DeskTime starts its online diary",
    description2:
      "On February 1st, the first article is published on the DeskTime blog. The blog is made as the place to share the latest productivity insights and tips on how to optimize one’s time. Its most popular blog post that describes how office environment affects productivity has since been read nearly 40'000 times.",
    img2: "https://desktime.com/assets/img/about/blog@3x.png",
  },
  {
    date1: "January 2012",
    title1: "Meeting DeskTime's most loyal customer",
    description1:
      "A USA based company, 121 USA LLC, signs up and becomes DeskTime’s customer in January 2012. Five years later, the team of 63 people is still using the app, which makes it our most loyal customer. Since the launch of the app, over 6000 other companies have joined and use DeskTime.",
    img1: "https://desktime.com/assets/img/about/loyal@3x.png",
    date2: "January 2012",
    title2: "New CEO takes over the reins",
    description2:
      "After spending 5 years in the pharmacy business and a year managing a startup, called SportSnaps, Artis Rozentals joins the DeskTime team and becomes its CEO.",
    img2: "https://desktime.com/assets/img/about/ceo@3x.png",
  },
  {
    date1: "August 2011",
    title1: "The team is growing - DeskTime's first full-time employee hired",
    description1:
      "The Canadian born Latvian, Julia Gifford, becomes the first full-time employee of DeskTime. Today, there are 7 people on the DeskTime team: the CEO, the customer relations manager, three programmers, one designer, and a content marketer.",
    img1: "https://desktime.com/assets/img/about/first-employee@3x.png",
    date2: "July 2011",
    title2: "Welcoming DeskTime's first registered user",
    description2:
      "Three weeks after the launch of the software, the very first customer registers and begins tracking time with DeskTime. Time tracking is still the core feature of the app: in 6 years, DeskTime has tracked over 171 million hours, which is almost 19552 years of time.",
    img2: "https://desktime.com/assets/img/about/first-user@3x.png",
  },
  {
    date1: "July 1st, 2011",
    title1: "Meet DeskTime - the automatic time tracking software!",
    description1:
      "DeskTime goes online on July 1st, 2011 under the wings of the Draugiem Group, the Latvia based IT company. The main idea of the time tracking software, from day one, is to increase workplace transparency between employees and management and to make sure work time is spent faithfully.",
    img1: "https://desktime.com/assets/img/about/desktime@3x.png",
    date2:"July 2011",
    title2:"Welcoming DeskTime's first registered user",
    description2:"Three weeks after the launch of the software, the very first customer registers and begins tracking time with DeskTime. Time tracking is still the core feature of the app: in 6 years, DeskTime has tracked over 171 million hours, which is almost 19552 years of time.",
    img2:"https://desktime.com/assets/img/about/first-user@3x.png"
  }
];
